import React from "react";
import { ssoRecruitmentLinkDatum } from "../entrypoints/participant_dashboard";
import App from "./app";
import { LANDING_PAGE_ZENDESK_SETTINGS } from "./shared/zendesk/zendesk_settings";
import ZendeskWidget from "./shared/zendesk/zendesk_widget";

export default function LandingPage({
  school,
  envBanner,
  zendeskKey,
}: {
  school?: {
    name: string;
    logo: string;
    isSsoEnabled: boolean;
    isSsoTestingEnabled: boolean;
    ssoConnection: string;
    id: string;
    shortName: string;
    ssoMenteeRecruitmentLinkData: ssoRecruitmentLinkDatum[];
    ssoMentorRecruitmentLinkData: ssoRecruitmentLinkDatum[];
  };
  envBanner?: string;
  zendeskKey?: string;
}) {
  // We are currently using the `App` component to drop the user onto the login page if they are not
  // authenticated into the app. This might look different once we move off of using rails views entirely.
  return (
    <App
      urlBase="/"
      pageName="Landing Page"
      school={school}
      envBanner={envBanner}
      reloadOnLogin={true}
    >
      <div></div>
      <ZendeskWidget {...LANDING_PAGE_ZENDESK_SETTINGS} zendeskKey={zendeskKey ?? ""} />
    </App>
  );
}
